import messageResource from "../messageResource";
import TemplateView from "../TemplateView"

export default class TypeOfWorkEmptyListPlaceholder extends TemplateView {
    constructor() {
        super();
    }

    templateHtml() {
        return "<div class='emptyListPlaceholder'>" +
               "    <div class='icon' />" +
               "    <div class='placeholder'><%-placeholder%></div>" +
               "</div>"
    }

    templateModel() {
        return {
            placeholder: messageResource.getMessage('billing_type.not_found')
        }
    }
}


// WEBPACK FOOTER //
// ./web/js/typesOfWork/TypeOfWorkEmptyListPlaceholder.js